import { render } from "./Agreement_android.vue?vue&type=template&id=d35c4336&scoped=true"
import script from "./Agreement_android.vue?vue&type=script&lang=js"
export * from "./Agreement_android.vue?vue&type=script&lang=js"

import "./Agreement_android.vue?vue&type=style&index=0&id=d35c4336&scoped=true&lang=less"

import exportComponent from "/opt/apps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d35c4336"]])

export default __exports__